module.exports = __webpack_public_path__ + "img/1.254c6b53.png";